import React, { useState } from 'react';
const faqs = [{
  q: '¿Cómo recibo el Megapack después de comprar?',
  a: 'El acceso es inmediato. Apenas confirmas el pago, recibes un email con tu enlace de descarga y puedes empezar a usar el kit en menos de 5 minutos, desde tablet, móvil o PC.'
}, {
  q: '¿Sirve para instructoras con poca experiencia?',
  a: '¡Por supuesto! El kit está pensado tanto para instructoras nuevas que necesitan estructura, como para profesionales con años de experiencia que buscan optimizar su tiempo. Los 6 tomos incluyen progresiones claras desde principiante hasta avanzado.'
}, {
  q: '¿Sirve para Reformer y Mat?',
  a: 'Sí. El Megapack incluye tomos específicos tanto para Reformer como para Mat Pilates con accesorios (bandas, pelotas, magic circle y más). Es un sistema completo, no solo una modalidad.'
}, {
  q: '¿Los 6 bonos están incluidos en el precio?',
  a: 'Sí, los 6 bonos estratégicos (Playlists, Anamnesis, Variaciones 3 Niveles, Calendario Anual, Script de Primera Clase y Pack de Flyers) están incluidos sin costo adicional en esta oferta de lanzamiento.'
}, {
  q: '¿Qué pasa con alumnas de distintos niveles al mismo tiempo?',
  a: 'La Guía de Variaciones en 3 Niveles (Bono 03) resuelve exactamente eso. Tienes el mismo ejercicio en versión Fundacional, Estándar y Avanzada — muestras las 3 y cada alumna elige la que le corresponde.'
}, {
  q: '¿Sirve si doy clases online?',
  a: 'Sí. Las rutinas y planificaciones funcionan perfectamente para clases presenciales 1 a 1, grupales en studio y también para clases online por Zoom o video. Tú eliges el formato.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'Todo el material viene en PDF de alta calidad, optimizado para visualizar en tablet, móvil y PC, o para imprimir si prefieres llevarlo en papel al studio. No necesitas ningún software especial.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una vez que lo descargas, el kit es 100% tuyo para siempre — sin suscripciones, sin pagos recurrentes, sin fechas de vencimiento.'
}, {
  q: '¿Tiene garantía de devolución?',
  a: 'Sí, tienes 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% de tu dinero sin preguntas, sin formularios y sin trámites complicados. Nuestra tasa de devolución es menor al 1%.'
}, {
  q: '¿Cómo puedo pagar? ¿Es seguro?',
  a: 'Aceptamos tarjetas de crédito, débito y métodos locales según tu país. El pago de USD 19 se procesa en tu moneda local a través de una pasarela 100% segura y encriptada. Tus datos nunca se comparten.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-20 sm:py-24 px-4" data-id="element-152">
      <div className="max-w-3xl mx-auto" data-id="element-153">
        <div className="text-center mb-10 sm:mb-12" data-id="element-154">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-155">
            ❓ Resolvemos tus dudas
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-156">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3 sm:space-y-4 mb-12 sm:mb-16" data-id="element-157">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_8px_24px_-12px_rgba(139,111,191,0.25)]' : 'border-border-light hover:border-primary/20'}`} data-id="element-158">
                <button className="w-full text-left px-5 sm:px-6 py-4 sm:py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-159">
                  <span className={`font-bold text-base sm:text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-160">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-161">
                    +
                  </span>
                </button>
                <div className={`px-5 sm:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-5 sm:pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-162">
                  <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-163">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-164">
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_15px_40px_-10px_rgba(15,139,111,0.5)]" data-id="element-165">
            🚀 ¡SÍ! QUIERO EL MEGAPACK COMPLETO
          </a>
          <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-166">
            <span data-id="element-167">⚡ Acceso inmediato</span>
            <span data-id="element-168">•</span>
            <span data-id="element-169">🛡️ Garantía 7 días</span>
            <span data-id="element-170">•</span>
            <span data-id="element-171">💳 USD 19 pago único</span>
          </p>
        </div>
      </div>
    </section>;
}